import { t } from "i18next";

export type AppModuleID =
  | "spreadsheet"
  | "deviations"
  | "routines"
  | "contractors"
  | "surveys"
  | "chats"
  | "posts"
  | "events"
  | "digitalKeys"
  | "booking"
  | "incomeOverview"
  | "fire"
  | "insights"
  | "branding"
  | "reports"
  | "activities"
  | "sensorData"
  | "checklistTemplates"
  | "maintenanceReports"
  | "globalCollections"
  | "documentAI"
  | "documentAIClassification"
  | "workflows"
  | "collections"
  | "customCollections"
  | "customDataTypes"
  | "timeTracking"
  | "costs"
  | "customAppSettings"
  | "customDashboards"
  | "tenantEconomy"
  | "smsNotifications";

export interface AppModule {
  name: string;
  id: AppModuleID;
  opt: "in" | "out";
}

export class AppModules {
  private static modules: AppModule[] = [
    { name: t("main.spreadsheet"), id: "spreadsheet", opt: "out" },
    { name: t("main.deviations"), id: "deviations", opt: "out" },
    { name: t("main.routines"), id: "routines", opt: "out" },
    { name: t("main.contractors"), id: "contractors", opt: "out" },
    { name: t("main.surveys"), id: "surveys", opt: "out" },
    { name: t("main.chats"), id: "chats", opt: "out" },
    { name: t("main.posts"), id: "posts", opt: "out" },
    { name: t("main.events"), id: "events", opt: "out" },
    { name: t("main.digitalKeys"), id: "digitalKeys", opt: "out" },
    { name: t("main.booking"), id: "booking", opt: "out" },
    { name: t("main.incomeOverview"), id: "incomeOverview", opt: "out" },
    { name: t("main.ICReports"), id: "reports", opt: "out" },
    { name: t("main.fire"), id: "fire", opt: "out" },
    { name: t("main.insights"), id: "insights", opt: "in" },
    { name: t("main.customBranding"), id: "branding", opt: "in" },
    { name: t("main.todos"), id: "activities", opt: "in" },
    { name: t("main.sensorData"), id: "sensorData", opt: "in" },
    { name: t("main.checklistTemplates"), id: "checklistTemplates", opt: "in" },
    { name: t("main.maintenanceReports"), id: "maintenanceReports", opt: "in" },
    { name: t("main.globalCollections"), id: "globalCollections", opt: "in" },
    { name: t("main.documentAI"), id: "documentAI", opt: "in" },
    { name: t("main.documentAIClassification"), id: "documentAIClassification", opt: "in" },
    { name: t("main.workflows"), id: "workflows", opt: "out" },
    { name: t("main.collections"), id: "collections", opt: "out" },
    { name: t("main.customCollections"), id: "customCollections", opt: "out" },
    { name: t("main.customDataTypes"), id: "customDataTypes", opt: "out" },
    { name: t("main.timeTracking"), id: "timeTracking", opt: "out" },
    { name: t("main.costs"), id: "costs", opt: "out" },
    { name: t("main.customAppSettings"), id: "customAppSettings", opt: "out" },
    { name: t("main.customDashboards"), id: "customDashboards", opt: "out" },
    { name: t("main.tenantEconomy"), id: "tenantEconomy", opt: "out" },
    { name: t("main.smsNotifications"), id: "smsNotifications", opt: "out" },
  ];

  static getModules(): AppModule[] {
    return this.modules;
  }
}

